// Reads the app-wide beforeinstallprompt store so our own Install button can fire it (spec v2 §16.3).
import { useCallback, useSyncExternalStore } from "react";
import { captureInstallPrompt, clearInstallPrompt, getInstallPrompt, subscribeInstallPrompt } from "@/lib/install-prompt";

export function useInstallPrompt() {
  captureInstallPrompt();   // idempotent; main.tsx already did it, this covers tests and other entry points
  const ev = useSyncExternalStore(subscribeInstallPrompt, getInstallPrompt, () => null);
  const prompt = useCallback(async () => {
    const e = getInstallPrompt();
    if (!e) return "unavailable" as const;
    await e.prompt();
    const { outcome } = await e.userChoice;
    clearInstallPrompt();
    return outcome;
  }, []);
  return { canPrompt: ev !== null, prompt };
}
